import React from 'react';
import { useAppSelector } from '../../../store';
import Page from './Page';

interface Props {
  assemblyGeneral: any;
  exportDate: string;
  pageNumber: number;
  totalPageNumber: number;
}

const FrontPage = ({ assemblyGeneral, exportDate, pageNumber, totalPageNumber }: Props) => {
  const theme = useAppSelector((state) => state.assemblyEditorSlice.theme);

  return (
    <Page isLastpage={totalPageNumber === pageNumber}>
      <div className="f-center" style={{ flexGrow: 1 }}>
        <div className="f-col f2-center" style={{ flexGrow: 1 }}>
          <img
            alt="PFD view"
            style={{
              objectFit: 'contain',
              height: 100,
              width: 'auto'
            }}
            src={theme.logo}
          />
          <div className="mt-5 mb-1">{exportDate}</div>
          <div className="font-regular" style={{ fontSize: 30 }}>
            {assemblyGeneral.name}
          </div>
          <div
            className="mt-3 mb-4"
            style={{ borderBottom: `1px solid var(--dark-grey)`, width: 100 }}
          />
          <div className="p-2" style={{ maxWidth: 600 }}>
            {assemblyGeneral.description}
          </div>
        </div>
      </div>
      <div className="f-row f1-end gap-2 mt-3" style={{ fontSize: 13 }}>
        <div>{`Page ${pageNumber}/${totalPageNumber}`}</div>
      </div>
    </Page>
  );
};

export default FrontPage;
